/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_TiktokInputs */

const en_us2_onboarding_how_heard_tiktok = /** @type {(inputs: Onboarding_How_Heard_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

const pt_br2_onboarding_how_heard_tiktok = /** @type {(inputs: Onboarding_How_Heard_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

const es_419_onboarding_how_heard_tiktok = /** @type {(inputs: Onboarding_How_Heard_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

const pt_pt2_onboarding_how_heard_tiktok = /** @type {(inputs: Onboarding_How_Heard_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

const fr_fr2_onboarding_how_heard_tiktok = /** @type {(inputs: Onboarding_How_Heard_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

const de_de2_onboarding_how_heard_tiktok = /** @type {(inputs: Onboarding_How_Heard_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

const it_it2_onboarding_how_heard_tiktok = /** @type {(inputs: Onboarding_How_Heard_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

/**
* | output |
* | --- |
* | "TikTok" |
*
* @param {Onboarding_How_Heard_TiktokInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_tiktok = /** @type {((inputs?: Onboarding_How_Heard_TiktokInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_TiktokInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_tiktok(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_tiktok(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_tiktok(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_tiktok(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_tiktok(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_tiktok(inputs)
	return en_us2_onboarding_how_heard_tiktok(inputs)
});
export { onboarding_how_heard_tiktok as "onboarding.how_heard.tiktok" }